export default "__VITE_ASSET__f04e1719__"